export const RESOLUTION = 32
